import { Nig, ExpedientDataFromLexon } from 'src/interfaces/EscritosLegales'
import { ExpedientDataFromLexonParsed } from 'src/interfaces/lexon'

type useExpedientOutput = {
  mapExpFromDb: (data: ExpedientDataFromLexon) => ExpedientDataFromLexonParsed
}

export default function useExpedient(): useExpedientOutput {
  const mapExpFromDb = (data: ExpedientDataFromLexon): ExpedientDataFromLexonParsed => {
    const expedient: ExpedientDataFromLexonParsed = {} as ExpedientDataFromLexonParsed
    const nig: Nig = {
      value: data.nig ?? '',
      N1: data.nig1 ?? '',
      N2: data.nig2 ?? '',
      N3: data.nig3 ?? '',
      N4: data.nig4 ?? '',
      N5: data.nig5 ?? ''
    }

    expedient.nig = nig
    expedient.proceeding = data.proceeding ? data.proceeding : ''
    expedient.destino = data.destino ? data.destino : null
    const orden = data.destino?.orden
    expedient.orden = orden && !Array.isArray(orden) ? orden : null
    if (expedient.destino && !expedient.orden) {
      expedient.destino = { ...expedient.destino, orden: null }
    }
    expedient.interveners = data.interveners ? data.interveners : ''

    return expedient
  }

  return {
    mapExpFromDb
  }
}
